import { render, staticRenderFns } from "./SupportNetwork.vue?vue&type=template&id=78bca948&scoped=true"
import script from "./SupportNetwork.vue?vue&type=script&lang=ts"
export * from "./SupportNetwork.vue?vue&type=script&lang=ts"
import style0 from "./SupportNetwork.vue?vue&type=style&index=0&id=78bca948&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bca948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78bca948')) {
      api.createRecord('78bca948', component.options)
    } else {
      api.reload('78bca948', component.options)
    }
    module.hot.accept("./SupportNetwork.vue?vue&type=template&id=78bca948&scoped=true", function () {
      api.rerender('78bca948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/SupportNetwork.vue"
export default component.exports